import {
    HEX, ARGB, WORKFLOW_LABEL, WORKFLOW_BG_HEX, WORKFLOW_FG_HEX, WORKFLOW_BG_ARGB, WORKFLOW_FG_ARGB,
} from '../constants/reportColors';

// Trainer-led "Under review" (specs/2026-10-27-trainer-led-under-review.md).
// Accepts both raw Moodle records (get_manual_modules / get_manual_course_progress:
// workflowenabled, currentstate, grade, timesubmitted, reviewstartedat) and the
// portal's Module (workflowEnabled, currentState, achievedCredits, timeSubmitted,
// reviewStartedAt).

const AWAITING_DECISION = ['proposed', 'updated'];

export const isUnderReview = (m: any): boolean => {
    if (!m) return false;
    const startedAt = Number(m.reviewstartedat ?? m.reviewStartedAt ?? 0);
    if (!startedAt) return false;
    // A newer submission is a new version: the old review doesn't count
    const submittedAt = Number(m.timesubmitted ?? m.timeSubmitted ?? 0);
    if (submittedAt > startedAt) return false;

    const workflow = !!(m.workflowenabled ?? m.workflowEnabled);
    if (workflow) {
        return AWAITING_DECISION.includes(String(m.currentstate ?? m.currentState ?? ''));
    }
    // Without the workflow: submitted and not graded yet
    const graded = m.grade !== undefined ? Number(m.grade) >= 0 : m.achievedCredits != null;
    return m.status === 'Submitted' && !graded;
};

export interface ProgressCell {
    label: string;
    bgHex: string;
    fgHex: string;
    bgArgb: string;
    fgArgb: string;
    // Under review cells show no date (it would read like "under review since")
    underReview: boolean;
}

// One consolidated-progress cell's status label and colours, for the portal
// preview (hex) and the Excel export (ARGB), so the two never drift apart.
export const progressCell = (mod: any): ProgressCell => {
    if (isUnderReview(mod)) {
        return { label: 'Under review', bgHex: HEX.underReviewBg, fgHex: HEX.underReviewText, bgArgb: ARGB.underReviewBg, fgArgb: ARGB.underReviewText, underReview: true };
    }
    if (mod.workflowenabled && mod.currentstate) {
        const s = mod.currentstate;
        return {
            label: WORKFLOW_LABEL[s] || s,
            bgHex: WORKFLOW_BG_HEX[s] || HEX.notStartedBg,
            fgHex: WORKFLOW_FG_HEX[s] || HEX.notStartedText,
            bgArgb: WORKFLOW_BG_ARGB[s] || ARGB.notStartedBg,
            fgArgb: WORKFLOW_FG_ARGB[s] || ARGB.notStartedText,
            underReview: false,
        };
    }
    const st = mod.status || 'Not Started';
    const done = st === 'Submitted' || st === 'Passed';
    const warn = st === 'Draft' || st === 'In Progress';
    return {
        label: st,
        bgHex: done ? HEX.passedBg : warn ? HEX.warnBg : HEX.notStartedBg,
        fgHex: done ? HEX.passedText : warn ? HEX.warnText : HEX.notStartedText,
        bgArgb: done ? ARGB.passedBg : warn ? ARGB.warnBg : ARGB.notStartedBg,
        fgArgb: done ? ARGB.passedText : warn ? ARGB.warnText : ARGB.notStartedText,
        underReview: false,
    };
};
